import { ICorrectResult } from "./CorrectResult";

/**
 * 纠错类型
 */
export enum CorrectType {
    /**
     * 长文本
     */
    longText = 1,
    /**
     * 短文本
     */
    shortText = 2,
    /**
     * 长文本纠错时分割出来的短文本
     */
    childOfLong = 3,
}
/**
 * 纠错状态
 */
export enum CorrectStatus {
    /**
     * 未纠错
     */
    notCorrect = 0,
    /**
     * 纠错中...
     */
    correcting = 1,
    /**
     * 纠错成功
     */
    success = 2,
    /**
     * 纠错失败
     */
    fail = 3,
}
/**
 * 纠错记录
 */
export type ICorrection = {
    /**
     * 纠错记录id
     */
    id?: number;
    /**
     * 纠错的用户
     */
    user_id?: number;
    /**
     * 纠错时所使用的文章id
     */
    article_id?: number;
    /**
     * 纠错类型
     */
    correct_type?: CorrectType;
    /**
     * {@link correct_type}为3时，对应的长文本纠错记录id
     */
    parent_id?: number;
    /**
     * 纠错状态
     */
    status?: CorrectStatus;
    /**
     * 纠错文本
     */
    text?: string;
    /**
     * 纠错结果
     */
    result?: ICorrectResult[][];
    /**
     * 纠错失败时的错误信息，可用于前端显示给用户
     */
    error_msg?: string;
    /**
     * 更新时间
     */
    updated_at?: number;
    /**
     * 创建时间
     */
    created_at?: number;
};
